var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { combineReducers } from 'redux';
import sesiones from '../gestor-sesiones/reducers';
import caducado from './caducado';
import configGeneral from './config-general';
import configBotones from './config-botones';
import configLibros from './config-libros';
import configVideos from './config-videos';
import configCaminos from './config-caminos';
import configVentanas from './config-ventanas';
import configIndice from './config-indice';
import configPortada from './config-portada';
import { pantallas, pantalla, pantallaProps } from './pantalla';
import pizarra from '../pizarra/reducers';
import paginasLibros from './paginas-libros';
import mascaras from '../mascaras/reducers';
import cartulina from '../cartulina/reducers';
import persiana from '../persiana/reducers';
import configIconosCaminos from './config-iconos-caminos';
import barraHerramientas from './barra-herramientas';
import textosUsuario from '../texto-usuario/reducers';
import imagenUsuarioVisible from './imagen-usuario-visible';
import textosUsuarioVisible from './textos-usuario-visible';
import reloj from './reloj';

var createReducers = function createReducers(dynamicReducers) {
  return combineReducers(_extends({
    // debug,
    caducado: caducado,
    configGeneral: configGeneral,
    configVentanas: configVentanas,
    configLibros: configLibros,
    configCaminos: configCaminos,
    configIconosCaminos: configIconosCaminos,
    configVideos: configVideos,
    configBotones: configBotones,
    configIndice: configIndice,
    configPortada: configPortada,
    paginasLibros: paginasLibros,
    pantallas: pantallas,
    pantalla: pantalla,
    pantallaProps: pantallaProps,
    //    ventana,
    //        pantallaLibro,
    //        pantallaVentana,
    imagenUsuarioVisible: imagenUsuarioVisible,
    textosUsuarioVisible: textosUsuarioVisible,
    pizarra: pizarra,
    mascaras: mascaras,
    cartulina: cartulina,
    persiana: persiana,
    barraHerramientas: barraHerramientas,
    textosUsuario: textosUsuario,
    reloj: reloj,
    sesiones: sesiones
  }, dynamicReducers));
};

export default createReducers;